import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const ConfigRoute: Route = {
  path: 'config',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/config.component').then((m) => m.ConfigComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
